<script setup lang="ts">
import { computed } from 'vue'
import type { DailyPanelProps } from '@/ui/daily-panel'
import { getStreamMessages } from '@/i18n/stream'
import { orderCopy } from '@/ui/order-widget'
const props = defineProps<Pick<DailyPanelProps, 'data' | 'locale'>>()
const copy = computed(() => getStreamMessages(props.locale, props.data.rateUnit))
const local = computed(() => orderCopy[props.locale])
const progress = computed(() => /\d/.test(props.data.expPercent) && Number.isFinite(props.data.expRatio) ? Math.round(props.data.expRatio * 100) : undefined)
</script>
<template>
  <div class="daily-progress-group">
    <div class="daily-progress-label"><span>{{ local.progress }}</span><strong data-panel-measure>{{ data.expPercent }}</strong></div>
    <div class="daily-progress-meter" role="progressbar" :aria-label="local.progress" :aria-valuenow="progress" :aria-valuetext="data.expPercent" :aria-valuemin="0" :aria-valuemax="100">
      <div class="daily-track daily-exp-track"><i :style="{ transform: `scaleX(${data.expRatio})` }" /></div>
    </div>
    <div class="daily-exp-meta"><span><span>{{ copy.eta }}</span><b data-exp-eta data-panel-measure>{{ data.eta }}</b></span><span><span>{{ data.expGainedLabel }}</span><b data-panel-measure>{{ data.expGained }}</b></span></div>
  </div>
</template>
